import React from 'react'
import Navbar from '../components/Navbar/Navbar'
import Footer from '../components/Footer/Footer'
import Appraisal from '../components/Howworks/Appraisal'
import Appraisalsecond from '../components/Howworks/Appraisalsecond'
import Contactfooter from '../components/Contactfooter'
import Appraisalthree from '../components/Howworks/Appraisalthree'
import HowitworksHero from '../components/Howworks/HowitworksHero'
import AppraisalFour from '../components/Howworks/Appreasalfour'

const Howworkspage = () => {
    return (
        <div>
            <Navbar />
            <HowitworksHero/>
            <Appraisal />
            <AppraisalFour/>
            <Appraisalsecond />
            <Appraisalthree/>
            <Contactfooter />


            <Footer />

        </div>
    )
}

export default Howworkspage